"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
DashboardService.$inject = ['api', '$q', 'Popeye'];
function DashboardService(api, $q, Popeye) {
    var service = {};
    service.fetchMessages = function () {
        return api.get('/messages', { dt: moment().utc().subtract(20, 'd').format() });
    };
    service.saveMessage = function (id, data) {
        return api.update('/messages/' + id, data);
    };
    service.checkNewMessages = function (id) {
        return api.get('/messages/count', { min_id: id });
    };
    service.getLastMessages = function (id) {
        return api.get('/messages', { min_id: id });
    };
    service.newMessage = function () {
        var delay = $q.defer();
        Popeye.openModal({
            templateUrl: "../scripts/apps/dashboard/views/new-message-dialog.html",
            modalClass: 'messageModal',
            controller: ['$scope', 'notify', function ($scope, notify) {
                    $scope.message = {
                        lon: 0,
                        lat: 0,
                        si: 0
                    };
                    $scope.severities = [
                        { code: 0, name: 'Info' },
                        { code: 1, name: 'Warning' },
                        { code: 2, name: 'Alert' }
                    ];
                    $scope.cancel = function (err) {
                        delay.reject(err);
                    };
                    $scope.ok = function (response) {
                        delay.resolve(response);
                        Popeye.closeCurrentModal(response);
                    };
                    $scope.confirm = function () {
                        return api.post('/messages', $scope.message).then(function (response) {
                            $scope.ok(response);
                        });
                        // console.log($scope.message);
                    };
                }]
        });
        return delay.promise;
    };
    return service;
}
exports.DashboardService = DashboardService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/services/dashboard.js
// module id = 476
// module chunks = 0